export class AppVersionResponse {
  _id: string = "";
  name: string = "";
  created_at: string = "";
  updated_at: string = "";
  app_type: number = 0;
  platform: number = 0;
  version: string = "";
  is_force_update: number = 0;
  constructor(data?: Partial<AppVersionResponse>) {
    Object.assign(this, data);
  }
}
